import { render, staticRenderFns } from "./goodsChangeDetail.vue?vue&type=template&id=552f8604&scoped=true"
import script from "./goodsChangeDetail.vue?vue&type=script&lang=js"
export * from "./goodsChangeDetail.vue?vue&type=script&lang=js"
import style0 from "./goodsChangeDetail.vue?vue&type=style&index=0&id=552f8604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552f8604",
  null
  
)

export default component.exports